import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import WorkforceLayout from "../../components/workforcelayout"
import WorkforceSEO from "../../components/workforceseo"
import WorkforceAboutWrap from "../../components/workforceaboutwrap"

import "../../style/main.scss"

import SubNav from "../../components/workforcesubnav"
import About from "../../components/workforceabout"
import Location from "../../components/location"

import styles from "./wrap.module.css"



const IndexPage = () => {
    const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <WorkforceLayout>
      <WorkforceSEO title="Securing A Remote Workforce Live 2020 | Wrap Up" />
      <SubNav />
      <WorkforceAboutWrap sponsors={sponsors} sponsorshipLevel={sponsorshipLevel} />
      {/*<section className={styles.blurb} id="blurb">
            
            <div className={styles.gridContainwrap}>
                <div className={styles.gridWrap}>
                    <h1>Wrap-Up</h1>
                    
                    <p className={styles.underwrap}>
                    <a href="https://event.on24.com/wcc/r/2336445/75CEB8E5F10446F0F270993013D6533E" target="_blank" className="pinkify">Watch the On-Demand session</a> from the first SNG Live Virtual Speaker Series of 2020. Over one hour, we featured three candid conversations with IT leaders, highlighting the rapid response to shift to remote tele-work during the early days of the pandemic<br /><br /> 
 
 Acting CIO of DHS, Beth Cappello and Mike Younkers, Senior Director of Systems Engineering for US Federal at Cisco, shared what they have earned from the pandemic response about the importance of planning and preparation for such an unexpected disruption.<br /><br />
  
 CIO of FCC, Francisco Salguero and Sean Frazier, Advisory CISO for Federal at Duo Security provided perspective on what is top of mind when it comes to securing remote workforces and how the use of personal machines has changed the way the agencies are approaching security.<br /><br />
  
 CIO of the Army Corps of Engineers, Dovarius Peoples and Rick Piña, Chief Technology Advisor of Public Sector at World Wide Technology discussed how agencies are ensuring to secure their growing networks while also making sure that people can get their job done.
                    </p>
                    
                    
                </div>
                
                
                <br /><br />
            </div>
            
  </section>*/}
    </WorkforceLayout>
  )
}

export default IndexPage